import React from 'react';
import injectSheet from 'react-jss';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

const styles = {
  btnWrapper: {
    // backgroundColor: 'red',
  },
  searchBtn: {
    borderColor: '#CBCBCB',
    borderRadius: '40px',
    color: '#979797',
    width: '104px',
    height: '2.625rem',
    fontFamily: 'Lato',
    fontSize: '1rem',
    '&:focus': {
      boxShadow: 'none',
    },
  },
  icon: {
    display: 'inline-block',
    float: 'left',
    composes: ['icon-search'],
    '&:before': {
      lineHeight: '28px',
    },
  },
  text: {
    display: 'inline-block',
    float: 'right',
  },
};

const SearchBtn = (props) => {
  const { classes } = props;
  return (
    <div className={classes.btnWrapper}>
      <Button className={classes.searchBtn} outline color="secondary">
        <i className={classes.icon} />
        <span className={classes.text}> Search </span>
      </Button>
    </div>
  );
};

SearchBtn.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default injectSheet(styles)(SearchBtn);



// WEBPACK FOOTER //
// ./src/components/SearchBtn.js